module.exports = __webpack_public_path__ + "html/login-screen.template.html";